import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import WidgetCard from "./WidgetCard";
import { Col, Radio, Row, Space, Tooltip } from "antd";
import TreemapModule from "highcharts/modules/treemap";
import { CATEGORY_OVERVIEW_SKU_FILTERS, IBBWinnersDistributionWidgetData } from "@ts/common-types";
import FiltersMenu from "../drop-downs/FiltersMenu";
import RevenueUnitsFilterMenu from "../misc/RevenueUnitsFilterMenu";
import { internationalizeNumericValue } from "@/ts/utils";


TreemapModule(Highcharts);

const BuyboxWinnersDistribution: React.FC<{
    widgetData: IBBWinnersDistributionWidgetData[];
    title?: string;
    currencySymbol?: string;
    tooltipFormatter?: (point: any) => string;
    dataLabelFormatter?: (point: any, currencySymbol?: string) => string;
    showFilter?: boolean;
    selectedRadioFilters?: CATEGORY_OVERVIEW_SKU_FILTERS;
    setSelectedRadioFilters?: (value: CATEGORY_OVERVIEW_SKU_FILTERS) => void;
    chartTitle?: string
}> = ({
    widgetData,
    title,
    currencySymbol,
    tooltipFormatter,
    dataLabelFormatter,
    showFilter = false,
    selectedRadioFilters = "",
    setSelectedRadioFilters = () => { },
    chartTitle = ""
}) => {

        const defaultDataLabelFormatter = React.useMemo(
            () =>
                function (this: any) {
                    return `<div style="text-align: center;">
                <div style="font-weight: bold;">${this?.point?.name}</div>
                <div style="margin-top: 5px;">${
                    currencySymbol ? currencySymbol : ""
                }${internationalizeNumericValue(this?.point?.value)}</div>
            </div>`;
                },
            [currencySymbol]
        );

        const defaultTooltipFormatter = React.useMemo(
            () =>
                function (this: any) {
                    return `<div style="text-align: center;">
                <div style="font-weight: bold;">MS% of ${this?.point?.subCat}% is ${this?.point?.value}</div>
            </div>`;
                },
            []
        );

        const chartOptions = {
            chart: {
                type: "treemap",
            },
            title: {
                text: chartTitle,
                style: { fontSize: "15px" }
            },
            credits: {
                enabled: false,
            },
            series: [
                {
                    layoutAlgorithm: "squarified",
                    data: widgetData,
                    dataLabels: {
                        enabled: true,
                        useHTML: true,
                        formatter: function (this: any) {
                            return dataLabelFormatter
                                ? dataLabelFormatter(this.point, currencySymbol)
                                : defaultDataLabelFormatter.call(this);
                        },
                        style: {
                            fontSize: "12px",
                            fontWeight: "bold",
                            textOutline: "none",
                        },
                    },
                },
            ],
            tooltip: {
                formatter: function (this: any) {
                    return tooltipFormatter
                        ? tooltipFormatter(this.point)
                        : defaultTooltipFormatter.call(this);
                },
            },
        };

        return (
            <WidgetCard className="my-4">
                <Row className="fs-5 mb-5 w-100" justify="space-between">
                    <Col span={24} className="d-flex  justify-content-between">
                        <h5>{title || "Buybox Winners Distribution"}</h5>
                        {showFilter && (
                            <div
                                style={{
                                    background: "white",
                                    borderRadius: "8px",
                                }}
                            >
                                <FiltersMenu
                                    menu={() => (
                                        <RevenueUnitsFilterMenu
                                            selectedRadioFilters={
                                                selectedRadioFilters as CATEGORY_OVERVIEW_SKU_FILTERS
                                            }
                                            setSelectedRadioFilters={
                                                setSelectedRadioFilters
                                            }
                                        />
                                    )}
                                />
                            </div>
                        )}
                    </Col>
                </Row>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={chartOptions}
                    key={selectedRadioFilters}
                />
            </WidgetCard>
        );
    };

export default BuyboxWinnersDistribution;